/**
 * @file Standalone photo viewer container.
 */

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import Helmet from 'react-helmet';
import get from 'lodash.get';

import { PhotoForStandaloneView } from '../../graphql/queries/photos';
import PhotoViewer from '../../components/product/PhotoViewer';
import { IMAGE_SIZE_CODE } from '../../constants/image-size-codes';
import LogoPoweredBy from '../../components/global/LogoPoweredBy';
import { getThumbBySize } from '../../util/photo';
import getConfig from '../../util/config';

class StandalonePhotoViewerContainer extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    photo: PropTypes.shape({
      id: PropTypes.string.isRequired,
      thumbnail_urls: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string.isRequired,
          width: PropTypes.number.isRequired,
          height: PropTypes.number.isRequired,
          size_code: PropTypes.string.isRequired,
        }),
      ),
    }),
  };

  render() {
    const { loading, error, photo } = this.props;

    if (loading) {
      return null;
    }

    const image = getThumbBySize(
      get(photo, 'thumbnail_urls'),
      IMAGE_SIZE_CODE.MEDIUM2X,
    );
    const {
      app: { pageUrl },
    } = getConfig();

    return (
      <Fragment>
        {image && (
          <Helmet>
            <title>Waldo Photos</title>
            <meta property="og:url" content={pageUrl} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content="Waldo Photos" />
            <meta property="og:description" content="Check out my photo!" />
            <meta property="og:image" content={image.url} />
            <meta property="og:image:width" content={image.width} />
            <meta property="og:image:height" content={image.height} />
          </Helmet>
        )}

        <PhotoViewer
          photoId={photo.id}
          photos={[photo]}
          navigationPath="/"
          maxSize={IMAGE_SIZE_CODE.MEDIUM2X}
          forceImageSize
          className="photo-viewer-light"
          error={error || !photo || !image}
        >
          <LogoPoweredBy className="waldo-powered-by-fixed-bottom" />
        </PhotoViewer>
      </Fragment>
    );
  }
}

const withPhotoForStandaloneView = graphql(PhotoForStandaloneView, {
  options: ({ match }) => ({
    variables: {
      id: match.params.photoId,
    },
  }),
  props: ({ data: { loading, error, photo } }) => ({
    loading,
    error,
    photo,
  }),
  skip: ({ match }) => !match.params.photoId,
});

export default compose(
  withRouter,
  withPhotoForStandaloneView,
)(StandalonePhotoViewerContainer);
